<div [class.isPrinting]="printService.isPrinting">
  <div class="row margin-bottom-10px" id="edit-link">
    <div class="col-md-12">
      <div class="card box-shadow-new-treatmentcycle border-left-sperm">
        <div class="card-header wh-header border-bottom-1px padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
          <div class="row nav-link-hand margin-left-0px margin-right-0px background-sperm data-color-white">
            <div class="col-md-6 padding-right-0px">
              <label class="margin-bottom-0px font-size-16px font-weight-normal" id="psa">
                <!--<i class="fas fa-circle light-gray-badge nav-link-hand  ">
                </i>-->
                Sperm Collection &amp; Processing
              </label>
            </div>
            <div class="col-md-6 float-right text-align-end padding-right-0px display-edit">
              <div class="row float-right margin-left-0px margin-right-0px">
                <div class="offset-md-3 col-md-1 padding-left-0px">
                  <!--<a class="nav-link-hand education-navlink " title="To View images">
        <span class="badge font-size-20px padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px"><i class="far fa-image"></i></span>
      </a>-->
                  <button type="button" (click)="Top()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload">
                    <i class="fas fa-long-arrow-alt-up font-size-11"></i>
                  </button>
                </div>
                <div class="col-md-1 padding-left-11px">
                  <!--<button type="button"
              class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
              name="upload">
        <i class="fas fa-plus font-size-11"></i>
      </button>-->
                  <button type="button" (click)="Bottom()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload" title="Goto Bottom">
                    <i class="fas fa-long-arrow-alt-down font-size-11 "></i>
                  </button>
                </div>
                <div class="col-md-1 padding-left-11px">
                  <a class="nav-link-hand education-navlink" *ngIf="GradingModel=='Well Culture'" title="print" (click)="printsource()">
                    <span class="badge font-size-14 padding-left-0px"><i class="fa fa-print"></i></span>
                  </a>
                  <a class="nav-link-hand education-navlink" *ngIf="GradingModel=='Droplet Culture'" title="print" (click)="printsourcedroplet()">
                    <span class="badge font-size-14 padding-left-0px"><i class="fa fa-print"></i></span>
                  </a>
                </div>
              </div>
              <!--<a class="nav-link-hand education-navlink margin-right-10px " title="edit">
    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
  </a>-->
           
            </div>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          <!--<div class="row margin-top-10">
            <div class="col-md-4 padding-left-15px padding-right-15px">
              <div class="card card-border-styles h-100">
                <div class="card-header wh-header header-new header-4 font-size-14">
                  Source
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <div class="row margin-top-10">
                    <div class="col-md-12 margin-top-5px">
                      <label class="font-size-12px margin-bottom-0px">Fresh/Frozen</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold ">Fresh</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Husband/Donor</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px ">Donor</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Storage Location Details</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">Cool Place</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Sperm Retrieval</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">PESA</label>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>-->

          <div class="row  margin-top-10">
            <div class="col-md-12 padding-left-24px">
              <div class="card border-all-1px">
                <div class="card-header background-primary font-size-15px padding-top-6px padding-bottom-6px color-Assign padding-left-10px padding-right-10px border-bottom-1px">
                  Source Details
                </div>
                <div class="card-body padding-all-0px">
                  <div class="row">
                    <div class="col-md-3 border-right-1px text-align-center padding-left-0px padding-right-0px">
                      <div class="" *ngIf="SpermEndInfo">
                        <label class="font-size-15px color-cyan font-weight-bold margin-top-16px">{{SpermEndInfo.SpermSourceFrom}}</label>
                      </div>
                    </div>
                    <div class="col-md-3 border-right-1px text-align-center padding-left-0px padding-right-0px">
                      <div class="" *ngIf="SpermEndInfo">
                        <label class="font-size-15px  font-weight-bold margin-top-16px">{{SpermEndInfo.SpermSource}}</label>
                      </div>
                    </div>

                    <div class="col-md-4 border-right-1px text-align-center padding-left-0px padding-right-0px">
                      <div>
                        <label class="font-size-12px margin-bottom-0px">Storage Location Details</label>
                      </div>
                      <div *ngIf="SpermEndInfo">
                        <label class="font-size-15px">{{SpermEndInfo.StorageLocationDetails}}</label>
                      </div>
                    </div>
                    <div class="col-md-2 text-align-center padding-left-0px padding-right-0px" *ngIf="GradingModel=='Well Culture'">
                      <div>
                        <label class="font-size-12px margin-bottom-0px">Technique</label>
                      </div>
                      <div class="" *ngIf="SpermEndInfo">
                        <label class="font-size-15px">{{SpermEndInfo.SpermRetrieval}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row  margin-top-10">
            <div class="col-md-12 padding-left-24px">
              <div class="card border-all-1px">
                <div class="card-header background-primary font-size-15px padding-top-6px padding-bottom-6px color-Assign padding-left-10px padding-right-10px border-bottom-1px">
                  Processing
                </div>
                <div class="card-body padding-all-0px">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-component margin-top-10 margin-bottom-0px table-processing">
                        <div class="table-responsive overflow-x">


                          <table class="table table-striped margin-left-zero"
                                 cols="auto,2*,*,*,*,*,*,*">


                            <tr>

                              <!--<th class="font-weight-normal td-padding-tb background-primary">

    </th>-->
                              <!--<th class="text-align-center">Day</th>-->
                              <!--<th class="font-weight-normal td-padding-tb background-primary font-size-12px">

    </th>-->
                              <!--<th class="font-weight-normal td-padding-tb background-primary font-size-12px">
      Post-Wash
    </th>-->
                              <!--<th class="text-align-center">Start Time</th>-->












                            </tr>
                            <tr>
                              <th rowspan="1" class="font-weight-normal td-padding-tb background-primary font-size-12px">
                                Date of Sample Collection
                              </th>
                              <td class="td-padding-tb font-size-12px">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.DateOfSampleCollection| date:'MMM-dd-yyyy'}}</label>
                              </td>
                              <!--<td class="td-padding-tb font-size-12px">19-JUN-19</td>-->
                            </tr>
                            <tr>
                              <th rowspan="1" class="font-weight-normal td-padding-tb background-primary font-size-12px">
                                Time of Sample Collection
                              </th>
                              <td class="td-padding-tb font-size-12px">

                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.TimeOFSampleCollection| date: 'hh:mm a'}}</label>

                              </td>
                              <!--<td class="td-padding-tb font-size-12px">9:45AM</td>-->
                            </tr>
                            <tr>
                              <th rowspan="1" class="font-weight-normal td-padding-tb background-primary font-size-12px">
                                Volume(ml)
                              </th>
                              <td class="td-padding-tb">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.Volume}}</label>
                              </td>
                              <!--<td class="td-padding-tb">7</td>-->
                            </tr>
                            <tr>
                              <th rowspan="1" class="font-weight-normal td-padding-tb background-primary font-size-12px">
                                Count(mil/ml)
                              </th>
                              <td class="td-padding-tb">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.Count}}</label>
                              </td>
                              <!--<td class="td-padding-tb">6</td>-->
                            </tr>
                            <tr *ngIf="GradingModel=='Well Culture'">
                              <th rowspan="1" class=" font-weight-normal td-padding-tb background-primary font-size-12px">
                                Motile Sperm Motility(%)
                              </th>
                              <td class="td-padding-tb">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.MotileSpermMotility}}</label>
                              </td>
                              <!--<td class="td-padding-tb">6</td>-->
                            </tr>

                            <tr>
                              <th rowspan="1" class=" font-weight-normal td-padding-tb background-primary font-size-12px td-padding-tb" *ngIf="GradingModel=='Well Culture'">
                                Active Progressivemotility (%)
                              </th>
                              <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px td-padding-tb" *ngIf="GradingModel=='Droplet Culture'">
                                Total Motility
                              </th>
                              <td class="td-padding-tb">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.ActiveProgressiveMotility}}</label>
                              </td>
                              <!--<td class="td-padding-tb">6</td>-->
                            </tr>
                            <tr>
                              <th rowspan="1" class=" font-weight-normal td-padding-tb background-primary font-size-12px">
                                Cellular Debris(mil/ml)
                              </th>
                              <td class="td-padding-tb">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.CellularDebris}}</label>
                              </td>
                              <!--<td class="td-padding-tb">+</td>-->
                            </tr>
                            <tr>
                              <th rowspan="1" class=" font-weight-normal td-padding-tb background-primary font-size-12px">
                                Method of Preparation
                              </th>
                              <td class="td-padding-tb">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.MethodofPreparation}}</label>
                              </td>
                              <!--<td class="td-padding-tb">DG</td>-->
                            </tr>
                            <tr>
                              <th rowspan="1" class=" font-weight-normal td-padding-tb background-primary font-size-12px">
                                Incubation Time (In Min)
                              </th>
                              <td class="td-padding-tb">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.IncubationTime| date: 'hh:mm a'}}</label>
                              </td>
                              <!--<td class="td-padding-tb">2</td>-->
                            </tr>
                            <tr>
                              <th rowspan="1" class=" font-weight-normal td-padding-tb background-primary font-size-12px">
                                Motile Sperm Count(mil/ml)
                              </th>
                              <td class="td-padding-tb">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.MotileSpermCount}}</label>
                              </td>
                              <!--<td class="td-padding-tb">2</td>-->
                            </tr>
                            <tr>
                              <th rowspan="1" class=" font-weight-normal td-padding-tb background-primary font-size-12px">
                                Motility(%)
                              </th>
                              <td class="td-padding-tb">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.Motility}}</label>
                              </td>
                              <!--<td class="td-padding-tb">2</td>-->
                            </tr>
                            <tr *ngIf="GradingModel=='Droplet Culture'">
                              <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px td-padding-tb">
                                Progressive Motility
                              </th>
                              <td class="td-padding-tb">
                                <!--<input type="number" class="form-control" placeholder="Progressive Motility" id="SpermEndInfo.ProgressiveMotility"
         [(ngModel)]="SpermEndInfo.ProgressiveMotility"
         name="SpermEndInfo.ProgressiveMotility" #ProgressiveMotility="ngModel"
         maxlength="100" required>-->
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.ProgressiveMotility}}</label>

                              </td>
                              <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                            </tr>
                            <tr *ngIf="GradingModel=='Droplet Culture'">
                              <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px td-padding-tb">
                                Morphology
                              </th>
                              <td class="td-padding-tb">
                                <!--<input type="number" class="form-control" placeholder="Morphology" id="SpermEndInfo.Morphology"
  [(ngModel)]="SpermEndInfo.Morphology"
  name="SpermEndInfo.Morphology" #Morphology="ngModel"
  maxlength="100" required>-->
                                <!--<CodeTypeValue CodeType="IVFMR" id="SpermEndInfo.Morphology"
                 [(ngModel)]="SpermEndInfo.Morphology" SelectedValue="SpermEndInfo.Morphology"
                 name="SpermEndInfo.Morphology"></CodeTypeValue>-->
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.Morphology}}</label>

                              </td>

                              <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                            </tr>
                            <tr *ngIf="GradingModel=='Droplet Culture'">
                              <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px td-padding-tb">
                                Non-Progressive Motility
                              </th>
                              <td class="td-padding-tb">
                                <!--<input type="number" class="form-control" placeholder="Non-Progressive Motility" id="SpermEndInfo.NonProgressiveMotility"
         [(ngModel)]="SpermEndInfo.NonProgressiveMotility"
         name="SpermEndInfo.NonProgressiveMotility" #NonProgressiveMotility="ngModel"
         maxlength="100" required>-->
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.NonProgressiveMotility}}</label>
                              </td>
                              <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                            </tr>
                            <tr *ngIf="GradingModel=='Droplet Culture'">
                              <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px td-padding-tb">
                                DFI(%)
                              </th>
                              <td class="td-padding-tb">
                                <!--<input type="number" class="form-control" placeholder="DFI" id="SpermEndInfo.DFI"
         [(ngModel)]="SpermEndInfo.DFI"
         name="SpermEndInfo.DFI" #DFI="ngModel"
         maxlength="100" required>-->
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.DFI}}</label>
                              </td>
                              <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                            </tr>
                            <tr>
                              <th rowspan="1" class=" font-weight-normal td-padding-tb background-primary font-size-12px td-padding-tb">
                                Notes
                              </th>
                              <td class="td-padding-tb">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.Notes}}</label>
                              </td>
                              <!--<td class="td-padding-tb">Remarks</td>-->
                            </tr>
                            <tr *ngIf="GradingModel=='Well Culture'">
                              <th rowspan="1" class=" font-weight-normal td-padding-tb background-primary font-size-12px td-padding-tb">
                                Slide Observed?
                              </th>
                              <td class="td-padding-tb">
                                <label class="margin-bottom-0px" *ngIf="SpermEndInfo">{{SpermEndInfo.SlideObserved}}</label>
                              </td>
                              <!--<td class="td-padding-tb">DOCT-91</td>-->
                            </tr>
                            <!--<tbody class="table-body">
    <tr>

      <td class="padding-right-0px td-padding-tb align-top">
        13-JUN-19


      </td>




      <td class="td-padding-tb">
        <div>Day 4 Grading</div>
        <div class="td-padding-tb td-elipsis2">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.</div>
      </td>

      <td class="td-padding-tb text-align-center align-top">
        <i class="fas fa-circle light-gray-badge nav-link-hand  ">
        </i>
      </td>

    </tr>

  </tbody>-->

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
